module.exports = __webpack_public_path__ + "media/images/background/bg_error-7a186b5fcf94770237d2ed65e02724c1.png";